import { useNavigate, useParams } from 'react-router-dom';
import { useUser } from '@shared/hooks';
import { eventService } from 'library/api/eventService';
import { useEvent, useMyTickets } from 'library/hooks/events';
import { useCertificateMessage } from '../common';
import useWindowDimensions from '../common/useWindowDimensions';

interface Ticket {
  email: string;
  first_name: string;
  last_name: string;
  middle_name: string;
  phone: string;
  prepayment_cost?: number;
}

interface BuyTickets {
  ticket: Ticket[];
  offer_accepted: boolean;
}

const createUserData = (user: any, prepaymentCost?: number): BuyTickets => ({
  ticket: [
    {
      email: user?.email || '',
      first_name: user?.first_name || '',
      last_name: user?.last_name || '',
      middle_name: user?.middle_name || '',
      phone: user?.phonenumber || '',
      prepayment_cost: prepaymentCost,
    },
  ],
  offer_accepted: true,
});

const useBuyTickets = () => {
  const { id, code } = useParams<{ id: string; code: string }>();
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const { onRedirect } = useCertificateMessage();
  const { user } = useUser();

  const onSubmit = async (prepaymentCost?: number) => {
    try {
      const userData = createUserData(user, prepaymentCost);
      const response = await eventService.buyTickets(id, userData);

      if (!response.data) {
        throw response;
      }

      return response.data.redirect_url;
    } catch (error) {
      // Обработка ошибок
    }
  };

  const onPaySuccess = () => navigate(`/events/${code}/${id}/tickets`);
  const onClose = () => navigate(`/events/${code}/${id}`);

  return {
    user,
    event: useEvent(),
    tickets: useMyTickets(),
    onClose,
    onSubmit: (prepaymentCost?: number) => onRedirect(() => onSubmit(prepaymentCost)),
    onPaySuccess,
    showCloseBtn: width <= 1024,
  };
};

export default useBuyTickets;
